import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { Avatar, Button, Chip, Grid, IconButton, Input, Stack } from '@mui/joy';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useUser } from '../../../hooks/useUser';
import usePostCommentMutation from '../../../mutations/postComment';

type TCommentFormProps = {
  postId: string;
  responseToCommentLabel: string | null;
  responseToCommentId: string | null;
  clearResponseToComment: () => void;
};

function CommentForm({
  postId,
  responseToCommentLabel,
  responseToCommentId,
  clearResponseToComment,
}: TCommentFormProps) {
  const [comment, setComment] = useState('');
  const user = useSelector((state: any) => state.user.singleUser);
  const userQuery = useUser();
  const postCommentMutation = usePostCommentMutation();

  if (!userQuery.isSuccess) {
    return null;
  }

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    if (!comment.length) return;
    postCommentMutation.mutate({
      owner: user._id,
      postBody: comment,
      postId: postId,
      responseToCommentId,
    });
    setComment('');
  };

  return (
    <Stack spacing={2}>
      {responseToCommentLabel && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Chip>Antwoord op {responseToCommentLabel}</Chip>
          <IconButton
            variant="plain"
            size="sm"
            onClick={clearResponseToComment}
          >
            <CloseRoundedIcon />
          </IconButton>
        </Stack>
      )}
      <Grid container spacing={1}>
        <Grid
          xs={0}
          lg={1}
          sx={{
            display: {
              xs: 'none',
              lg: 'flex',
            },
          }}
        >
          <Avatar src={`${user?.imageUrl}`} alt="profile" />
        </Grid>
        <Grid xs={10} lg={10}>
          <Input
            type="text"
            placeholder={'Reactie...'}
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
            }}
            disabled={postCommentMutation.isLoading}
          />
        </Grid>
        <Grid xs={2} lg={1}>
          <Button
            onClick={handleFormSubmit}
            disabled={!comment.length}
            loading={postCommentMutation.isLoading}
          >
            <SendRoundedIcon />
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default CommentForm;
